import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavDropdown } from 'react-bootstrap';

class NavDropdownHover extends Component {
	constructor(props) {
		super(props);

		this.handleMouseEnter = this.handleMouseEnter.bind(this);
		this.handleMouseLeave = this.handleMouseLeave.bind(this);
		this.handleToggle = this.handleToggle.bind(this);

		this.state = {
			isOpen: false
		};
	}

	handleMouseEnter() {
		if (this.props.openOnHover) {
			this.setState({ isOpen: true });
		}
	}

	handleMouseLeave() {
		if (this.props.openOnHover) {
			this.setState({ isOpen: false });
		}
	}

	handleToggle(open) {
		if (!this.props.openOnHover) {
			this.setState({ isOpen: open });
		}
	}

	render() {
		const { openOnHover, children, ...rest } = this.props;
		return <NavDropdown onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} onToggle={this.handleToggle} open={this.state.isOpen} {...rest}>
			{children}
		</NavDropdown>;
	}
}

NavDropdownHover.propTypes = {
	openOnHover: PropTypes.bool
};

export default NavDropdownHover;